import React, { useEffect, useRef, useState } from 'react';

import Monitor from './Monitor.js';

const HEIGHT = 150;

const PulseMonitor = ({
  label,
  className,
  color,
  sample,
  readout,
  initialValue,
  valueId,
  unit,
  renderReadout,
  sampleStep = 1,
}) => {
  const canvasRef = useRef(null);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    if (!context) return undefined;
    const monitor = new Monitor({ sample, color, sampleStep });
    let width;
    let animationFrame;
    let readoutSecond = -1;

    const resize = () => {
      width = Math.max(1, Math.floor(canvas.parentElement.getBoundingClientRect().width));
      const pixelRatio = window.devicePixelRatio || 1;
      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(HEIGHT * pixelRatio);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${HEIGHT}px`;
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    };

    const draw = (timestamp) => {
      const seconds = timestamp / 1000;
      monitor.plot(context, width, HEIGHT, seconds);
      if (Math.floor(seconds) !== readoutSecond) {
        readoutSecond = Math.floor(seconds);
        setValue(readout(seconds));
      }
      animationFrame = window.requestAnimationFrame(draw);
    };

    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(canvas.parentElement);
    animationFrame = window.requestAnimationFrame(draw);
    window.addEventListener('resize', resize);
    return () => {
      window.cancelAnimationFrame(animationFrame);
      observer.disconnect();
      window.removeEventListener('resize', resize);
    };
  }, [color, sample, readout, sampleStep]);

  return (
    <div
      className={`monitor-row ${className}`}
      style={{ '--monitor-color': `rgb(${color.join(',')})` }}
    >
      <div className="monitor-waveform">
        <canvas
          ref={canvasRef}
          width={120}
          height={HEIGHT}
          aria-label={`${label} waveform, simulated healthy resting adult`}
          style={{ display: 'block' }}
        />
        <span className="monitor-waveform-label">{label}</span>
      </div>
      <div className="monitor-readout">
        {renderReadout ? (
          renderReadout(value)
        ) : (
          <>
            <span className="monitor-readout-label">{unit}</span>
            <span id={valueId} className="monitor-numeric">
              {Math.round(value)}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default PulseMonitor;
